import * as Sentry from '@sentry/react';
import { useEffect } from 'react';
import { isRouteErrorResponse, useRouteError } from 'react-router-dom';

/**
 * Page « Oups » du routeur (errorElement de main.tsx). Elle attrape tout
 * crash React de rendu. Jusqu'au 18/10/2026 elle ne faisait que
 * `console.error` : les crashs vus par les agences (sprint du 07/10) étaient
 * invisibles dans Sentry. On remonte maintenant l'erreur avec l'URL.
 */
export default function ErrorPage() {
  const error = useRouteError();

  useEffect(() => {
    console.error(error);
    Sentry.captureException(error instanceof Error ? error : new Error(String(error)), {
      tags: { source: 'route-error-page' },
      extra: { url: window.location.href },
    });
  }, [error]);

  const detail = isRouteErrorResponse(error)
    ? `${error.status} ${error.statusText}`
    : error instanceof Error
      ? error.message
      : null;

  return (
    <div id="error-page" style={{ padding: '48px 24px', textAlign: 'center', fontFamily: 'sans-serif' }}>
      <h1>Oups !</h1>
      <p>Une erreur inattendue s'est produite. Notre équipe en est informée.</p>
      {detail && (
        <p>
          <i>{detail}</i>
        </p>
      )}
      <p>
        <a href="/">Retour à l'accueil</a>
      </p>
    </div>
  );
}
